import { ContinueStripeLink, DisableGoogleAnalytics, GetGoogleAnalytics, GetStripeIntegration, GetStripeLink, SetGoogleAnalytics, SetStripeContact } from "../../../connection/integrations";
import { AsyncAction } from "../../../types/actions";

export const INTEGRATIONS_STRIPE_STATUS = "INTEGRATIONS_STRIPE_STATUS";
export function getStripeStatus(token: string): AsyncAction {
	return {
		type: INTEGRATIONS_STRIPE_STATUS,
		promise: GetStripeIntegration(token)
	};
}

export const INTEGRATIONS_STRIPE_STARTUP = "INTEGRATIONS_STRIPE_STARTUP";
export function startStripeIntegration(token: string): AsyncAction {
	return {
		type: INTEGRATIONS_STRIPE_STARTUP,
		promise: GetStripeLink(token)
	};
}

export const INTEGRATIONS_CONTINUE_STRIPE = "INTEGRATIONS_CONTINUE_STRIPE";
export function continueStripeIntegration(token: string): AsyncAction {
	return {
		type: INTEGRATIONS_CONTINUE_STRIPE,
		promise: ContinueStripeLink(token)
	};
}

export const INTEGRATIONS_STRIPE_CONTACT = "INTEGRATIONS_STRIPE_CONTACT";
export function setStripeContact(token: string, email: string): AsyncAction {
	return {
		type: INTEGRATIONS_STRIPE_CONTACT,
		promise: SetStripeContact(token, email)
	};
}

export const GET_GOOGLE_ANALYTICS = "GET_GOOGLE_ANALYTICS";
export function getGoogleAnalytics(token: string, channel: number): AsyncAction {
	return {
		type: GET_GOOGLE_ANALYTICS,
		promise: GetGoogleAnalytics(token, channel)
	};
}

export const SET_GOOGLE_ANALYTICS = "SET_GOOGLE_ANALYTICS";
export function setGoogleAnalytics(token: string, channel: number, ga: string): AsyncAction {
	return {
		type: SET_GOOGLE_ANALYTICS,
		promise: SetGoogleAnalytics(token, channel, ga)
	};
}

export const DISABLE_GOOGLE_ANALYTICS = "DISABLE_GOOGLE_ANALYTICS";
export function disableGoogleAnalytics(token: string, channel: number): AsyncAction {
	return {
		type: DISABLE_GOOGLE_ANALYTICS,
		promise: DisableGoogleAnalytics(token, channel)
	};
}